import { Children, isValidElement } from 'react'
import { useInputCreditCardProps } from '../../hooks'
import { InputCreditCardButton } from '../input-credit-card-button'
import * as Comp from './input-credit-card-actions.styles'

export const InputCreditCardActions = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const { size, isActive, inputValue, id, hasError, disabled, readonly } =
    useInputCreditCardProps()
  const isFilled = inputValue.length > 0

  const hasCleanerButton = Children.toArray(children).some(child => {
    return isValidElement(child) && child.type === InputCreditCardButton
  })

  return (
    <Comp.Actions
      size={size}
      role="form"
      isActive={isActive}
      isFilled={isFilled}
      hasCleanerButton={hasCleanerButton}
      aria-label={id}
      hasError={hasError}
      disabled={disabled}
      readonly={readonly}
    >
      {children}
    </Comp.Actions>
  )
}
